import { useNavigate } from 'react-router-dom';
import { ArrowRight, Upload, Search, BadgeCheck } from 'lucide-react';
import '@styles/pages/how-it-works.css';

const STEPS = [
  {
    number: '01',
    icon: Upload,
    title: 'Send in the case file',
    description:
      'Snap a photo or upload a PDF of your medical bill. Agent Loop takes it from here.',
    fox: '/images/mascot/fox-reading-bill.png',
  },
  {
    number: '02',
    icon: Search,
    title: 'Agent Loop investigates',
    description:
      'Our clever fox sniffs out overcharges, catches billing errors, and finds negotiation leverage you\'d never spot on your own.',
    fox: '/images/mascot/fox-investigating.png',
  },
  {
    number: '03',
    icon: BadgeCheck,
    title: 'Case closed, you save',
    description:
      'Agent Loop cracks the case, average savings of 60-80%. No savings, no fee.',
    fox: '/images/mascot/fox-cape.png',
  },
];

export default function HowItWorks() {
  const navigate = useNavigate();

  return (
    <main className="hiw-page">
      {/* Hero */}
      <section className="hiw-hero">
        <div className="hiw-hero-content">
          <span className="hiw-badge">  How it works  </span>
          <h1 className="hiw-title">Three steps. <span className="italic">One clever fox.</span></h1>
          <p className="hiw-subtitle">
            Send Agent Loop your bill and let our fox do the detective work.
            No risk, 100% money-back guarantee.
          </p>
        </div>
        <div className="hiw-hero-fox">
          <img
            src="/images/mascot/fox-cutting-bill.png"
            alt="Agent Loop cutting through your bill"
          />
        </div>
      </section>

      {/* Steps */}
      <section className="hiw-steps">
        {STEPS.map((step) => (
          <div key={step.number} className="hiw-step">
            <div className="hiw-step-number">{step.number}</div>
            <div className="hiw-step-fox">
              <img src={step.fox} alt="" />
            </div>
            <div className="hiw-step-content">
              <div className="hiw-step-icon">
                <step.icon size={22} />
              </div>
              <h3 className="hiw-step-title">{step.title}</h3>
              <p className="hiw-step-desc">{step.description}</p>
            </div>
          </div>
        ))}
      </section>

      {/* CTA */}
      <section className="hiw-cta">
        <h2 className="hiw-cta-title">Ready to outsmart your medical bills?</h2>
        <p className="hiw-cta-desc">Put Agent Loop on the case. No savings, no fee.</p>
        <button className="hiw-cta-btn" onClick={() => navigate('/add-bill')}>
          Upload Your Bill <ArrowRight size={18} />
        </button>
      </section>
    </main>
  );
}
